import { render, staticRenderFns } from "./achievementList.vue?vue&type=template&id=b3184d68&scoped=true"
import script from "./achievementList.vue?vue&type=script&lang=js"
export * from "./achievementList.vue?vue&type=script&lang=js"
import style0 from "./achievementList.vue?vue&type=style&index=0&id=b3184d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3184d68",
  null
  
)

export default component.exports